import i18next from 'i18next';

i18next.addResources('es', 'stageSelector', {
  allStages: 'Todas las etapas',
  stages: 'Etapas',
  profile: 'Perfil',
  preExecution: 'Pre-ejecución',
  execution: 'Ejecución',
  finished: 'Concluido',
  apply: 'Aplicar'
});

i18next.addResources('en', 'stageSelector', {
  allStages: 'All stages',
  stages: 'Stages',
  profile: 'Profile',
  preExecution: 'Pre-execution',
  execution: 'Execution',
  finished: 'Completed',
  apply: 'Apply'
});

i18next.addResources('pt', 'stageSelector', {
  allStages: 'Todas as etapas',
  stages: 'Etapas',
  profile: 'Perfil',
  preExecution: 'Pré-execução',
  execution: 'Execução',
  finished: 'Concluído',
  apply: 'Aplicar'
});
